import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ProjectContext } from "../../ProjectContext";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { ethers } from "ethers";

function LoginBox() {
  const { link_ref_address } = useParams();
  const {
    account,
    dbuser,
    toastSuccess,
    toastError,
    setRefAddress,
    settings,
    CheckReffaral,
  } = useContext(ProjectContext);

  const { openConnectModal } = useConnectModal();
  const [isProcessing, setIsProcessing] = useState(false);
  const [showLoginButton, setShowLoginButton] = useState(false);
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const validateAfterWalletConnect = async () => {
      if (!account) return;

      setIsProcessing(true);
      setShowLoginButton(false);
      setShowError(false);

      const normalizedAccount = account.toLowerCase();
      const normalizedDbUserAddress = dbuser?.address?.toLowerCase();

      // 1. User is already registered → go to dashboard
      if (normalizedAccount === normalizedDbUserAddress) {
        navigate("/dashboard");
        setIsProcessing(false);
        return;
      }

      // 2. Wallet connected, user not in DB
      if (!link_ref_address) {
        setShowError(true); // Show "Referral Not Found"
      } else {
        setRefAddress(link_ref_address);
        setShowLoginButton(true);
      }

      setIsProcessing(false);
    };

    validateAfterWalletConnect();
  }, [account, dbuser, link_ref_address, navigate, setRefAddress]);

  const handleOnClick = async () => {
    setIsProcessing(true);
    try {
      const referralCheck = await CheckReffaral();

      if (referralCheck?.code === 200) {
        navigate("/dashboard");
      } else if (referralCheck?.code === 400) {
        // toastError("Referral is not active.");
      } else {
        toastError("Unexpected error with referral check.");
      }
    } catch (error) {
      console.error("Error checking referral:", error);
      toastError("Failed to verify referral address.");
    } finally {
      setIsProcessing(false);
    }
  };

  const addCustomToken = async () => {
    try {
      if (!window.ethereum) {
        toastError("MetaMask is not installed.");
        return;
      }

      if (!ethers.utils.isAddress(settings?.dnet)) {
        toastError("Invalid token address");
        return;
      }

      const tokenAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: settings.dnet,
            symbol: "DNET",
            decimals: 6,
          },
        },
      });

      tokenAdded
        ? toastSuccess("Token added successfully!")
        : toastError("Token addition failed.");
    } catch (error) {
      toastError("Error adding token.");
      console.error("Error adding token:", error);
    }
  };

  const addCustomNetwork = async () => {
    try {
      if (!window.ethereum) {
        toastError("MetaMask is not installed.");
        return;
      }

      const customNetwork = {
        chainId: "0xa4b1",
        chainName: "Arbitrum One",
        rpcUrls: ["https://arb1.arbitrum.io/rpc"],
        nativeCurrency: {
          name: "Ether",
          symbol: "ETH",
          decimals: 18,
        },
        blockExplorerUrls: ["https://arbiscan.io"],
      };

      await window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [customNetwork],
      });

      toastSuccess("Arbitrum network added successfully!");
    } catch (error) {
      console.error("Error adding custom network:", error);
      toastError("Failed to add custom network.");
    }
  };

  return (
    <div className="padding-top container">
      <div className="d-flex justify-content-center row mx-2">
        <div className="col-xl-6 col-md-8 mb-4 box-login-size">
          <div className="text-white text-center rounded shadow-lg">
            <img
              width={150}
              alt="logo"
              src="../assets/images/logo/logo-light.svg"
              className="mb-5 img-fluid"
            />
            <div className="d-flex justify-content-center">
              {!account ? (
                <button
                  type="button"
                  onClick={openConnectModal}
                  className="button-1 px-5 my-2 my-lg-0 text-white"
                >
                  <span className="text_button">Connect Wallet</span>
                </button>
              ) : isProcessing ? (
                <div className="processing-message">Processing...</div>
              ) : showError ? (
                <h3>Your Referral Link Not Found</h3>
              ) : showLoginButton ? (
                <button
                  className="button-1 px-5 my-2 my-lg-0"
                  onClick={handleOnClick}
                  disabled={isProcessing}
                >
                  <div className="dots_border" />
                  <img
                    className="sparkle img-fluid"
                    alt="lock-icon"
                    src="../assets/images/lock-icon.png"
                  />
                  <span className="text_button">Log in</span>
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <button className="button-1 px-5 my-2 my-lg-0 mr-3" onClick={addCustomToken}>
          <div className="dots_border" />
          <span className="text_button">Add Token</span>
        </button>
        <button className="button-1 px-5 my-2 my-lg-0 ml-2" onClick={addCustomNetwork}>
          <div className="dots_border" />
          <span className="text_button">Add Chain</span>
        </button>
      </div>
    </div>
  );
}

export default LoginBox;
